/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCorporationsCorporationIdContactsLabels200Ok
 */
export interface GetCorporationsCorporationIdContactsLabels200Ok {
    /**
     * label_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdContactsLabels200Ok
     */
    labelId: number;
    /**
     * label_name string
     * @type {string}
     * @memberof GetCorporationsCorporationIdContactsLabels200Ok
     */
    labelName: string;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdContactsLabels200Ok interface.
 */
export function instanceOfGetCorporationsCorporationIdContactsLabels200Ok(value: object): value is GetCorporationsCorporationIdContactsLabels200Ok {
    if (!('labelId' in value) || value['labelId'] === undefined) return false;
    if (!('labelName' in value) || value['labelName'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdContactsLabels200OkFromJSON(json: any): GetCorporationsCorporationIdContactsLabels200Ok {
    return GetCorporationsCorporationIdContactsLabels200OkFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContactsLabels200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdContactsLabels200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'labelId': json['label_id'],
        'labelName': json['label_name'],
    };
}

export function GetCorporationsCorporationIdContactsLabels200OkToJSON(json: any): GetCorporationsCorporationIdContactsLabels200Ok {
    return GetCorporationsCorporationIdContactsLabels200OkToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdContactsLabels200OkToJSONTyped(value?: GetCorporationsCorporationIdContactsLabels200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label_id': value['labelId'],
        'label_name': value['labelName'],
    };
}

